export var ErrorCode;
(function (ErrorCode) {
    // Configuration errors
    ErrorCode["NOT_CONFIGURED"] = "NOT_CONFIGURED";
    ErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    ErrorCode["MISSING_DEPENDENCY"] = "MISSING_DEPENDENCY";
    // Download errors
    ErrorCode["DOWNLOAD_FAILED"] = "DOWNLOAD_FAILED";
    ErrorCode["DOWNLOAD_TIMEOUT"] = "DOWNLOAD_TIMEOUT";
    ErrorCode["INVALID_URL"] = "INVALID_URL";
    ErrorCode["UNAUTHORIZED_HOST"] = "UNAUTHORIZED_HOST";
    ErrorCode["BUNDLE_TOO_LARGE"] = "BUNDLE_TOO_LARGE";
    // Validation errors
    ErrorCode["CHECKSUM_MISMATCH"] = "CHECKSUM_MISMATCH";
    ErrorCode["SIGNATURE_INVALID"] = "SIGNATURE_INVALID";
    ErrorCode["VERSION_DOWNGRADE"] = "VERSION_DOWNGRADE";
    ErrorCode["INVALID_BUNDLE_FORMAT"] = "INVALID_BUNDLE_FORMAT";
    // Storage errors
    ErrorCode["STORAGE_FULL"] = "STORAGE_FULL";
    ErrorCode["FILE_NOT_FOUND"] = "FILE_NOT_FOUND";
    ErrorCode["PERMISSION_DENIED"] = "PERMISSION_DENIED";
    // Update errors
    ErrorCode["UPDATE_FAILED"] = "UPDATE_FAILED";
    ErrorCode["ROLLBACK_FAILED"] = "ROLLBACK_FAILED";
    ErrorCode["BUNDLE_NOT_READY"] = "BUNDLE_NOT_READY";
    // Platform errors
    ErrorCode["PLATFORM_NOT_SUPPORTED"] = "PLATFORM_NOT_SUPPORTED";
    ErrorCode["NATIVE_ERROR"] = "NATIVE_ERROR";
})(ErrorCode || (ErrorCode = {}));
export class NativeUpdateError extends Error {
    constructor(code, message, details, originalError) {
        super(message);
        this.code = code;
        this.message = message;
        this.details = details;
        this.originalError = originalError;
        this.name = 'NativeUpdateError';
        Object.setPrototypeOf(this, NativeUpdateError.prototype);
    }
    toJSON() {
        return {
            name: this.name,
            code: this.code,
            message: this.message,
            details: this.details,
            stack: this.stack,
        };
    }
}
export class ConfigurationError extends NativeUpdateError {
    constructor(message, details) {
        super(ErrorCode.INVALID_CONFIG, message, details);
        this.name = 'ConfigurationError';
    }
}
export class DownloadError extends NativeUpdateError {
    constructor(code, message, details, originalError) {
        super(code, message, details, originalError);
        this.name = 'DownloadError';
    }
}
export class ValidationError extends NativeUpdateError {
    constructor(code, message, details) {
        super(code, message, details);
        this.name = 'ValidationError';
    }
}
export class StorageError extends NativeUpdateError {
    constructor(code, message, details, originalError) {
        super(code, message, details, originalError);
        this.name = 'StorageError';
    }
}
export class UpdateError extends NativeUpdateError {
    constructor(code, message, details, originalError) {
        super(code, message, details, originalError);
        this.name = 'UpdateError';
    }
}
//# sourceMappingURL=errors.js.map